import React from 'react';

import InfoTooltip from '../../components/InfoTooltip/InfoTooltip';
import { HEALTH_BUCKET_LIST } from './gatewayHealth';

const TOTAL_INFO =
    'Total gateways that sent at least one health report in the window. The buckets to the right split these by state and add up to this number.';

// When `onToggleBucket` is provided the bucket cards double as filter buttons: clicking
// one adds that bucket (identified by its `overviewKey`, which is also the API's `health`
// filter value) to the selection, clicking it again removes it. Several may be selected
// at once, and the list below then shows the union. Without the handler (the fleet-health
// page) the cards stay purely presentational.
const FleetHealthCards = ({ overview, selectedBuckets = [], onToggleBucket }) => {
    const total = overview?.total ?? 0;
    const pct = value => (total > 0 ? Math.round((100 * value) / total) : 0);
    const clickable = typeof onToggleBucket === 'function';

    return (
        <div className="gateways-overview__summary">
            <div className="gateways-overview__stat gateways-overview__stat--total">
                <span className="gateways-overview__stat-value">{total}</span>
                <span className="gateways-overview__stat-label">
                    Gateways reporting
                    <InfoTooltip tooltip={TOTAL_INFO} />
                </span>
            </div>
            {/* Card accent is the bucket's own colour, the same one the history chart
                draws that bucket in, so a card and a bar for the same state always match. */}
            {HEALTH_BUCKET_LIST.map(({ key, label, color, overviewKey, info }) => {
                const content = (
                    <>
                        <span className="gateways-overview__stat-value">
                            {overview?.[overviewKey] ?? 0}
                            <span className="gateways-overview__stat-pct">{pct(overview?.[overviewKey] ?? 0)}%</span>
                        </span>
                        <span className="gateways-overview__stat-label">
                            {label}
                            {/* The icon may sit inside a filter button; a tap on it (esp. on
                                touch, where hover means tap) must not toggle the filter. */}
                            <span onClick={event => event.stopPropagation()}>
                                <InfoTooltip tooltip={info} />
                            </span>
                        </span>
                    </>
                );

                if (!clickable) {
                    return (
                        <div key={key} className="gateways-overview__stat" style={{ borderTopColor: color }}>
                            {content}
                        </div>
                    );
                }

                const selected = selectedBuckets.includes(overviewKey);
                return (
                    <button
                        key={key}
                        type="button"
                        className={`gateways-overview__stat gateways-overview__stat--clickable${
                            selected ? ' gateways-overview__stat--selected' : ''
                        }`}
                        style={{ borderTopColor: color }}
                        aria-pressed={selected}
                        title={selected ? `Stop showing "${label}" gateways` : `Add "${label}" gateways to the list below`}
                        onClick={() => onToggleBucket(overviewKey)}
                    >
                        {content}
                    </button>
                );
            })}
        </div>
    );
};

export default FleetHealthCards;
